module.exports = __webpack_public_path__ + "static/media/view game.927b03e1.svg";